import type { FacetValue } from "../facet-value";

type ArrayFunction<T, U> = (value: T, index: number, array: T[]) => U;
type ArrayUnaryFunction<T> = ArrayFunction<T, T>;
type ArrayPredicate<T> = (value: T, index: number, array: T[]) => boolean;

export const not =
  <T>(predicate: ArrayPredicate<T>): ArrayPredicate<T> =>
  (...args) =>
    !predicate(...args);

/*                                     */

export const isSelected: ArrayPredicate<FacetValue> = (value: FacetValue) => value.checked;
export const isPopular: ArrayPredicate<FacetValue> = (value: FacetValue) => value.popular;
export const isInDenseMode: ArrayPredicate<FacetValue> = (value: FacetValue) => value.inDenseMode;
export const isNba: ArrayPredicate<FacetValue> = (value: FacetValue) => value.nba || false;
export const isNotSelected: ArrayPredicate<FacetValue> = not(isSelected);
export const isNotPopular: ArrayPredicate<FacetValue> = not(isPopular);
export const isNotInDenseMode: ArrayPredicate<FacetValue> = not(isInDenseMode);

export const addNameAndFeatureTracking =
  (parentId: string, name: string, offset?: number): ArrayUnaryFunction<FacetValue> =>
  (facetValue: FacetValue, index: number) => {
    if (!facetValue) {
      return facetValue;
    }
    const { featureTracking, ...rest } = facetValue;
    return {
      name,
      ...rest,
      ...(featureTracking && {
        featureTracking: {
          parentId,
          ...(offset !== undefined && { position: `${index + offset}` }),
          method: rest.popular ? "popular" : undefined,
          ...featureTracking,
          labels: {
            ...(featureTracking.labels || {}),
          },
        },
      }),
    };
  };
